export const devConsole = {
  /**
   * Adds a timestamp to the log message.
   * @returns {string} - The formatted timestamp as "yyyy-mm-dd hh:mm:ss".
   */
  getTimestamp: (): string => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Month is 0-based
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  },

  /**
   * Logs messages to the console if the environment is "development".
   * @param {...unknown[]} messages - The messages to log.
   */
  log: (...messages: unknown[]): void => {
    if (process.env.NODE_ENV === 'development') {
      console.log(devConsole.getTimestamp(), ...messages);
    }
  },

  /**
   * Logs errors to the console if the environment is "development".
   * @param {...unknown[]} messages - The error messages to log.
   */
  error: (...messages: unknown[]): void => {
    if (process.env.NODE_ENV === 'development') {
      console.error(devConsole.getTimestamp(), ...messages);
    }
  },

  /**
   * Logs informational messages to the console if the environment is "development".
   * @param {...unknown[]} messages - The informational messages to log.
   */
  info: (...messages: unknown[]): void => {
    if (process.env.NODE_ENV === 'development') {
      console.info(devConsole.getTimestamp(), ...messages);
    }
  },

  /**
   * Logs warnings to the console if the environment is "development".
   * @param {...unknown[]} messages - The warning messages to log.
   */
  warn: (...messages: unknown[]): void => {
    if (process.env.NODE_ENV === 'development') {
      console.warn(devConsole.getTimestamp(), ...messages);
    }
  },
};
